<template>
    <div v-if="field.extra.attributes.includes('vue_form_value')"/>
    <v-text-field
            color="main_color"
            v-else
            :label="label"
            outlined
            v-model="formValues[field.nombre]"
            :placeholder="field.ayuda"
            :class="field.extra.attributes"
            :readonly="readonly"
            :rules="rules"
            :aria-required="true"
            :error="field.extra.attributes.includes('error_field')"
            :error-messages="errorMessage"
            @input="v => {toUppercase(v)}"
            @blur="tryExecuteApiAjaxEvent('blur')"
            :name="Math.random()"
    >
        <template v-slot:append-outer class="mt-0" v-if="apiAjax && formValues[field.nombre]">
            <v-btn color="primary" @click="tryExecuteApiAjaxEvent('blur')"><v-icon>fas fa-search</v-icon></v-btn>
        </template>
    </v-text-field>
</template>

<script>
    import procedureFormValidator from "../../../form/procedure.form.validator";
    import {mapState} from "vuex";

    export default {
        name: "TextField",
        props: ['field', 'readonly', 'label', 'formValues', 'apiAjax'],

        data() {
            return {
                rules: [],
                apiAjaxExecuted: false,
                errorMessage: ''
            }
        },

        watch:{
            '$store.state.procedures.apiAjaxContent'(){
                if (this.apiAjaxExecuted){
                    if (this.proceduresStore.apiAjaxContent !== null && this.proceduresStore.apiAjaxContent.error){
                        this.errorMessage = this.proceduresStore.apiAjaxContent.error
                        this.apiAjaxExecuted = false
                    }else if (Array.isArray(this.proceduresStore.apiAjaxContent) && this.proceduresStore.apiAjaxContent.length === 0){
                        this.errorMessage = 'No se econtraron resultados'
                    }else {
                        this.errorMessage = ''
                    }
                }
            }
        },

        computed: {
            ...mapState({proceduresStore: state => state.procedures}),
        },

        mounted() {
            this.addAllValidations()

            if (this.field.extra.attributes.includes('vue_form_value')){
                this.$root.$on(`form_value_${this.field.nombre}`, this.setNewDynamicFormValue)
            }
        },

        methods: {
            getLabel(){
                if (this.field.validacion.required){
                    return '* ' + this.field.etiqueta
                }

                return this.field.etiqueta
            },

            addAllValidations(){
                let rules = []

                rules.push(procedureFormValidator.input.required(this.field.validacion.required, this.readonly))

                if (this.field.validacion.curp || this.field.nombre == 'curp'){
                    rules.push(procedureFormValidator.input.curp)
                }else if (this.field.validacion.rfc || this.field.nombre == 'rfc'){
                    rules.push(procedureFormValidator.input.rfc)
                }
                if (this.field.validacion.min_length || this.field.validacion.max_length){
                    rules.push(procedureFormValidator.input.min_max_length(this.field.validacion.min_length, this.field.validacion.max_length))
                }
                if (this.field.validacion.exact_length){
                    rules.push(procedureFormValidator.input.exact_length(this.field.validacion.exact_length))
                }
                if (this.field.validacion.numeric){
                    rules.push(procedureFormValidator.input.numeric)
                }

                this.rules = rules
            },

            toUppercase(value){
                if (this.field.extra.attributes && this.field.extra.attributes.includes('uppercase')){
                    this.formValues[this.field.nombre] = value.toUpperCase()
                }
            },

            tryExecuteApiAjaxEvent(eventType){
                if (this.apiAjax != null && this.formValues[this.field.nombre]){
                    if (eventType === this.apiAjax['event']){
                        this.apiAjaxExecuted = true
                        this.$root.$emit(`fire_${this.apiAjax.originFieldId}`)
                    }
                }
            },

            /**
             * Set form value dynamically, from javascript calls
             */
            setNewDynamicFormValue(newValue){
                this.formValues[this.field.nombre] = newValue
            }
        }
    }
</script>

<style>
    .uppercase input{text-transform: uppercase}
</style>